import BaseModelAPI from '../BaseModelAPI';

export default class DataSource extends BaseModelAPI {
	static entity = 'datasource';
	static entityName = 'datasource';

	constructor(){

	/*APP_MODEL_DEFINITION*/
			this.id = '';
			this.name = '';
			this.isFromUpload = false;
			this.isSavedToBackend = true;
			this.uploadValidationMessage = '';
			this.uploadValidationStatus = '';
	/*END_APP_MODEL_DEFINITION*/
	}

}